{
    "actions": {
        "page": {
            "add_contracts": {
                "title": "Affecter des contrats",
                "gateway": "Contrats passerelle",
                "external": "Contrats externes"
            }
        },
        "row": {
            "update_label": "Modifier le libellé",
            "remove": "Supprimer",
            "domiciliation": "Carte de domiciliation"
        }
    },
    "application": {
        "ACCORDEMV": "Accord EMV",
        "AMEX": "Amex Proximité",
        "AMEXCLESS": "Amex Sans Contact",
        "CASHAGENCE": "Cash-Agence",
        "CBCLESS": "CB Sans Contact",
        "CBEMV": "CB Proximité",
        "CBENSEIGNE": "Aurore",
        "CBVAD": "CB Vente à distance",
        "CHEQUE-ELC": "Chèque ELC",
        "CMCICSCHEME": "CUP CIC",
        "CONECS": "CONECS",
        "CONECSCLESS": "CONECS Sans Contact",
        "CUPNATIXIS": "CUP Natixis",
        "DCCFCC": "DCC Global Blue",
        "DCCFEXCO": "DCC Fexco",
        "DCC NATIXIS": "DCC Natixis",
        "DCCPLBS": "DCC PLBS",
        "FINTRAX": "Fintrax",
        "JCBEMV": "JCB Proximité",
        "JCBVAD": "JCB Vente à distance",
        "LASERCOFINOGA": "Laser Cofinoga",
        "MULTISSIME": "Multissime",
        "NXSMULTI": "CUP-Diners-Discover Natixis",
        "OPTALION": "Optalion LCL",
        "P3FEMV": "P3F EMV",
        "PASSCAREFOUR": "Pass Carrefour",
        "PAYLUDD": "Payludd",
        "PLBS+": "PLBS+",
        "PLBS": "PLBS",
        "PLBSGCB": "PLBS GCB",
        "PNFOZITO": "PNF OZITO",
        "POINTVERT": "Point Vert",
        "PREAUTOCMUT": "Pré-auto CM",
        "QUASI-CASH": "Quasi-Cash",
        "RELAISCE": "Relais CE",
        "SOFINCO": "Sofinco",
        "UNKNOWN_APPLICATION": "Application inconnue",
        "ALMA": "ALMA",
        "UPI_CA_CONTACT": "UPI CA Contact",
        "UPI_CA_SANS_CONTACT": "UPI CA Sans Contact",
        "TOP3_3XCB": "TOP3 3XCB"
    },
    "filter": {
        "placeholder": {
            "contract": "Filtrer par # contrat",
            "rank": "Filtrer par rang",
            "bank_code": "Filtrer par code banque",
            "label": "Filtrer par libellé contrat 2",
            "merchant_label": "Filtrer par libellé contrat",
            "x25_address": "Filtrer par Centre X25",
            "serial_number": "Filtrer par # série",
            "manufacturer": "Filtrer par constructeur",
            "itp": "Filtrer par ITP",
            "registration_number": "Filtrer par SIRET",
            "legal_name": "Filtrer par marchand",
            "last_iccid": "Filtrer par SIM",
            "model": "Filtrer par modèle",
            "specification": "Filtrer par spécification",
            "bulletins": "Filtrer par bulletins",
            "cb_approval": "Filtrer par # agrément CB",
            "cb_version": "Filtrer par version CB",
            "pci_version": "Filtrer par version PCI",
            "pci_pp_version": "Filtrer par version PCI PP",
            "idsa": "Filtrer par IDSA",
            "mcc": "Filtrer par MCC",
            "merchant_name": "Filtrer par nom du marchand",
            "legal_and_business_name": "Filtrer par raison sociale",
            "er_code": "Filtrer par code ERT"
        }
    },
    "keys": {
        "application": "Application",
        "contract_number": "Contrat",
        "rank": "Rang",
        "bank_code": "Code banque",
        "label": "Libellé contrat 2",
        "merchant_label": "Libellé contrat",
        "created_at": "Créé le",
        "added_at": "Date d'ajout",
        "x25_address": "Centre X25",
        "serial_number": "# série",
        "manufacturer": "Constructeur",
        "itp": "ITP",
        "cb_version": "CB",
        "registration_number": "SIRET",
        "legal_name": "Marchand",
        "last_iccid": "Carte SIM",
        "last_remote_collection_date": "Dernière TLC",
        "last_ssl_version": "Certificat",
        "model": "Modèle",
        "specification": "Spécifications",
        "bulletins": "Bulletins appliqués",
        "ert_code": "ERT",
        "cb_approval": "# agrément CB",
        "cb_approval_date": "Date agrément CB",
        "pci_version": "Version PCI",
        "pci_expiration_date": "Date fin PCI",
        "pci_pp_version": "Version PCI PP",
        "pci_pp_expiration_date": "Date fin PCI PP",
        "expiration_date": "Fin de comm.",
        "end_of_deployment_date": "Fin de déploiement",
        "end_of_use_date": "Retrait terrain",
        "idsa": "IDSA",
        "mcc": "MCC",
        "merchant_name": "Nom marchand",
        "legal_and_business_name": "Raison sociale"
    },
    "modal": {
        "update_label": {
            "title": "Modifier le libellé du contrat",
            "text": "Libellé contrat",
            "success": "Contrat mis à jour avec succès !",
            "error": "Une erreur est survenue lors de la mise à jour"
        },
        "delete": {
            "title": "Confirmation de suppression",
            "text": "Les informations de paiements de ce contrat ne seront pas supprimées et restent accessibles. Cette action entrainera la suppression de ce contrat associé à des groupes.",
            "success": "Suppression de ce contrat réussie avec succès !",
            "error": "Une erreur est survenue lors de la suppression de ce contrat",
            "warning": "Veuillez confirmer la demande de suppression pour ce contrat"
        },
        "domiciliation": {
            "title": "Carte de domiciliation",
            "application": "Application",
            "contract_number": "Contrat",
            "title_contract_only": "Contrat n°{{number}}",
            "iso_track": "Caractères piste magnétique",
            "copy_to_clipboard": {
                "copy": "Copier",
                "success": "Copié dans le Presse-papiers"
            }
        },
        "import": {
            "explanations": {
                "header": "Vous pouvez ajouter des contrats à un compte marchand par fichier CSV. Le fichier à importer doit contenir les 5 colonnes suivantes :",
                "contract": "contrat : numéro de contrat à 7 chiffres",
                "application": "application : identifie l'application du contrat (CBEMV, CBCLESS, AMEX, ALMA...)",
                "bank_code": "bank_code : code de la banque acquéreur",
                "rank": "rank : numéro de rang sur 3 chiffres. Il peut comporter une ou plusieurs valeurs séparées par des virgules (exemple \"001,002,007\"), définir une plage (exemple 001-010) ou être vide pour autoriser tous les rangs",
                "contract_label": "contract_label : libellé pour identifier chacun des contrats renseignés",
                "warning": "Attention : seul un contrat existant sur la passerelle pourra être ajouté à un compte marchand. Si un contrat n'est pas connu de notre passerelle, il ne sera pas ajouté."
            },
            "error": {
                "BAD_FILE_FORMAT_EXCEPTION": "Le format du fichier est invalide.",
                "TOO_MANY_RESOURCES": "L’import de contrats par fichier CSV est limité à 10 000 contrats",
                "UNEXPECTED_ERROR": "Une erreur inattendue est survenue.",
                "INVALID_REQUEST": "Une erreur inattendue est survenue.",
                "alreadyExistingMerchantContract": "Ce contrat marchand existe déjà",
                "bankCodeIsInvalid": "Code banque invalide",
                "contractIsInvalid": "Numéro de contrat invalide",
                "contractLabelIsInvalid": "Label trop long",
                "rankIsInvalid": "Rang invalide",
                "applicationIsInvalid": "Application invalide",
                "get_example_file": "Veuillez télécharger le fichier exemple.",
                "header": "L’ajout des contrats a été effectué partiellement à cause de la présence d'erreurs dans le CSV. Vous trouverez ci-dessous la liste des numéros de contrat qui n'ont pas été créés et leurs erreurs :",
                "footer": "Vous pouvez corriger ces erreurs et retenter l'opération de création de contrats ensuite."
            },
            "confirmation": "Cette opération va ajouter {{numberOfContracts}} contrats au compte marchand. Souhaitez-vous continuer ?",
            "success": "Contrats ajoutés avec succès !"
        }
    },
    "rank": {
        "all": "Tous les rangs",
        "range": "Du {{from}} au {{to}}"
    },
    "ert": {
        "10": "10 - Paiement de Proximité",
        "20": "20 - Vente à distance",
        "41": "41 - Paiement par automate de classe I ADM",
        "42": "42 - Paiement par automate de class II.1 ADM",
        "43": "43 - Paiement sur automate à authentification porteur obligatoire",
        "45": "45 - Paiement par automate de classe I SST",
        "46": "46 - Paiement par automate de classe II.1 SST",
        "60": "60 - Quasi Cash",
        "80": "80 - PLBS",
        "empty": "-",
        "UNKNOWN": "Inconnu"
    },
    "tooltips": {
        "mail_to_unknown_application": "Cliquez ici pour nous indiquer l'application"
    },
    "mailto_unknown_application": {
        "subject": "Application inconnue / ITP: {{itp}} / n°: {{posTerminalSerialNumber}}",
        "object": "Merci de nous indiquer le nom de l'application correspondante.",
        "object_line_two": "D'avance merci,",
        "signature": "L'équipe support.",
        "tooltip": "Cliquez ici pour nous indiquer l'application"
    }
}